<h1 mat-dialog-title
    class="draggable-dialogue-header"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle>
    Site Images
</h1>

<div class="icons-div">
    <mat-selection-list #icons
                        [(ngModel)]="this.SelectedIconIds"
                        [multiple]="true"
                        class="icons-mat-selection-list">
        <mat-list-option *ngFor="let siteIcon of this.SiteIcons" [value]="siteIcon.id">
            <img src="{{this.ImageSource(siteIcon)}}" alt="{{siteIcon.name}}" width=32 height=32 style="transform: translateY(8px);"/>
            <span class="icon-name-span">{{siteIcon.name}}</span>
        </mat-list-option>
    </mat-selection-list>
</div>

<div mat-dialog-actions>
    <button mat-flat-button
            [disabled]="(this.SelectedIconIds == null) || (this.SelectedIconIds.length == 0)"
            style="margin-left: 10px; width: 200px;"
            color="primary"
            (click)="this.copyIconUrlClicked()">
        {{this.CopyImagesButtonTitle}}
    </button>

    <button mat-flat-button
            [disabled]="false"
            style="margin-left: 10px;"
            (click)="this.cancelClicked()">
        Close
    </button>
</div>
